<template>
    <div class="card-item">
          <div class="card-item__label">{{ label }}</div>
          <div class="card-item__content"><slot></slot></div>
        </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                required: true,
            }
        },
       
    }
</script>

<style lang="scss" scoped>
.card-item{
    width: 30%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: 20px;
    &__label{
      flex: 0 0 100px;
      text-align: left;
      padding-right: 10px;
      color: #777F8F;
    }
    &__content{
      flex:1;
      color: #1D2944;
    }
  }

</style>